import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Point from './Point';
import './LandingPage.css';

import {
  requestAnimationFrame,
  cancelAnimationFrame
} from '../../utils/animationFrame';

class LandingCanvas extends Component {
  frameId= null;
  points = [];

  componentDidMount () {
    this.setup();
    window.addEventListener('resize', this.reSize);
    this.draw();
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.reSize);
    cancelAnimationFrame(this.frameId);
  }

  setup () {
    this.calSize();
    this.ctx = this.canvas.getContext('2d');
    const { width, height } = this.canvas;
    const { pointRadius, pointFillColor, pointStrokeColor, pointLife, pointSpeed } = this.props;
    for (let i = 0; i < 100; i++) {
      this.points.push(new Point(this.ctx, width, height, pointRadius, pointFillColor, pointStrokeColor, pointLife, pointSpeed));
    }
  }

  reSize = () => {
    const { width, height } = this.canvas;
    this.calSize();
    this.points.forEach(p => {
      p.updateSize(width, height);
    });
  }

  calSize = () => {
    this.canvas.width = this.wrapper.clientWidth;
    this.canvas.height = this.wrapper.clientHeight;
  }

  draw = () => {
    const { minDis, lineStrokeColor, canvasBgColor, numOfPoints } = this.props;
    const { width, height } = this.canvas;

    this.ctx.fillStyle = canvasBgColor;
    this.ctx.fillRect(0, 0, width, height);

    for (let i = 0; i < numOfPoints; i++) {
      const p = this.points[i];
      p.show();
      p.update();
      for (let j = 0; j < numOfPoints; j++) {
        const p1 = this.points[j];
        if (i !== j) {
          const dx = p1.x - p.x;
          const dy = p1.y - p.y;
          const dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < minDis) {
            this.ctx.beginPath();
            this.ctx.strokeStyle = lineStrokeColor;
            this.ctx.moveTo(p.x, p.y);
            this.ctx.lineTo(p1.x, p1.y);
            this.ctx.stroke();
            this.ctx.closePath();
          }
        }
      }
    }
    this.frameId = requestAnimationFrame(this.draw);
  }

  render () {
    return (
      <div className="landingPage" ref={wrapper => this.wrapper = wrapper}>
        <canvas
          ref={canvas => this.canvas = canvas }
        />
        { this.props.children }
      </div>
    );
  }
}

LandingCanvas.propTypes = {
  children: PropTypes.node,
  numOfPoints: PropTypes.number,
  minDis: PropTypes.number,
  pointRadius: PropTypes.number,
  pointLife: PropTypes.number,
  pointSpeed: PropTypes.number,
  pointFillColor: PropTypes.string,
  pointStrokeColor: PropTypes.string,
  lineStrokeColor: PropTypes.string,
  canvasBgColor: PropTypes.string
};

LandingCanvas.defaultProps = {
  numOfPoints: 100,
  minDis: 100,
  pointRadius: 1,
  pointLife: 150,
  pointSpeed: Math.random() * 0.3 + 0.2,
  pointFillColor: '#000',
  pointStrokeColor: '#000',
  lineStrokeColor: 'rgba(0 ,0 ,0 ,0.3)',
  canvasBgColor: 'rgba(0,0,0,0)',
};

export default LandingCanvas;



// WEBPACK FOOTER //
// ./src/Components/LandingPage/LandingPage.js